// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
      config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  };

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    new Swiper(".sp-swiper1", {
      autoplay: {
        disableOnInteraction: false,
        delay: 2500,
      },
      spaceBetween: 0,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
    });

    new Swiper(".sp-swiper2", {
      autoplay: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slideShadows: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: ".sp-pagination",
        clickable: true,
      },
    });

    new Swiper(".sp-swiper3", {
      autoplay: {
        disableOnInteraction: false,
        delay: 2500,
      },
      spaceBetween: 0,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      pagination: {
        el: ".sp-pagination",
        clickable: true,
      },
    });
    const prods = window.prods
    $(".reduce").click(function () {
      let input = $(this).siblings("input")[0];
      let num = Number(input.value) - 1;
      if (num > 0) {
        input.value = num;
        $(this).parent().siblings(".price-group").find(".price1 span").html(((prods[0].price * num / 100).toFixed(2) + ''))
        $(this).parent().siblings(".price-group").find(".price2 span").html(((prods[0].compare_at_price * num / 100).toFixed(2) + ''))
      }
    });
    $(".add").click(function () {
      let input = $(this).siblings("input")[0];
      let num = Number(input.value) + 1;
      input.value = num;
      $(this).parent().siblings(".price-group").find(".price1 span").html(((prods[0].price * num / 100).toFixed(2) + ''))
      $(this).parent().siblings(".price-group").find(".price2 span").html(((prods[0].compare_at_price * num / 100).toFixed(2) + ''))
    });
    $('.sp-btn-style').click(function () {
      let num = $('#calcNumber').val()
      let index = $(this).data("index")
      let id = $(this).data("id")
      if (index) {
        num = 1
      }
      window.location.href = '/cart/' + id + ':' + num
    })

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top: offsetTop * $("div#root").css("zoom") - 240 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }



  let spprev = document.querySelector(".sp-swiper-btn-prev");
  let spnext = document.querySelector(".sp-swiper-btn-next");
  spnext.addEventListener("click", function () {
    let items = document.querySelectorAll(".sp-swiper-item");
    document.querySelector(".sp-swiper-box").appendChild(items[0]);
  });
  spprev.addEventListener("click", function () {
    let items = document.querySelectorAll(".sp-swiper-item");
    document.querySelector(".sp-swiper-box").prepend(items[items.length - 1]);
  });

  // 自动轮播，每3秒切换一次
  let autoSwiperInterval = setInterval(() => spnext.click(), 3000);

  // 支持手指/鼠标滑动切换，并在滑动时暂停自动轮播，滑动结束后恢复
  (function () {
    const swiperBox = document.querySelector('.sp-swiper-box');
    if (!swiperBox) return;
    let startX = 0;
    let isTouch = false;
    let threshold = 50; // 滑动阈值
    let mouseDown = false;
    let mouseStartX = 0;

    // 触摸事件
    swiperBox.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) {
        isTouch = true;
        startX = e.touches[0].clientX;
        clearInterval(autoSwiperInterval); // 手指按下时暂停自动轮播
      }
    });
    swiperBox.addEventListener('touchmove', function (e) {
      // 阻止页面滚动
      if (isTouch) e.preventDefault();
    }, { passive: false });
    swiperBox.addEventListener('touchend', function (e) {
      if (!isTouch) return;
      let endX = e.changedTouches[0].clientX;
      let diff = endX - startX;
      if (diff > threshold) {
        // 向右滑，上一项
        spprev.click();
      } else if (diff < -threshold) {
        // 向左滑，下一项
        spnext.click();
      }
      isTouch = false;
      autoSwiperInterval = setInterval(() => spnext.click(), 3000); // 手指离开时恢复自动轮播
    });

    // 鼠标事件（PC端）
    swiperBox.addEventListener('mousedown', function (e) {
      mouseDown = true;
      mouseStartX = e.clientX;
      clearInterval(autoSwiperInterval); // 鼠标按下时暂停自动轮播
    });
    swiperBox.addEventListener('mousemove', function (e) {
      if (mouseDown) e.preventDefault();
    });
    swiperBox.addEventListener('mouseup', function (e) {
      if (!mouseDown) return;
      let mouseEndX = e.clientX;
      let diff = mouseEndX - mouseStartX;
      if (diff > threshold) {
        spprev.click();
      } else if (diff < -threshold) {
        spnext.click();
      }
      mouseDown = false;
      autoSwiperInterval = setInterval(() => spnext.click(), 3000); // 鼠标松开时恢复自动轮播
    });
    // 鼠标离开区域时取消
    swiperBox.addEventListener('mouseleave', function (e) {
      mouseDown = false;
    });
  })();




}

mainRender();